export const environment = {
  baseApiUrl: "https://dev-api.hub.zunzunsolutions.com",
  baseAppUrl: "https://dev.hub.zunzunsolutions.com",
  oAuthDomain:
    "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_UGbUdGQ7L",

  appName: "dev-Hub",

  endpoints: {
    orders: {
      orders: "/v1/entity/ORDER_ITEM",
      parseOrderPDF: "/v1/orders/parse-pdf",
      generateOrderPDF: "/v1/orders/generate",
      download_csv: "/v1/orders/pullsheet-csv",
      salesOrders: "/v1/orders/sale-orders",
    },
    pull_sheet: {
      pull_sheets: "/v1/entity/PULLSHEET",
    },
    bill_of_lading: {
      bill_of_lading_list: "/v1/entity/BILL_OF_LANDING",
    },
  },
};
